import { Button } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';

const ChangeModelSucceed = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div
      style={{
        background: `url('/assets/header_background.svg')`,
        position: 'absolute',
        width: '100%',
        backgroundColor: '#f9fcff',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 80px)',
      }}
    >
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <img
          src={'/assets/success.svg'}
          alt={'icon'}
          style={{ marginRight: '10px', width: '300px' }}
        />

        <div
          style={{
            fontSize: '24px',
            fontWeight: 700,
            lineHeight: '31.2px',
            alignItems: 'center',
            color: '#000',
          }}
        >
          The model has been updated
        </div>
        <div
          style={{
            fontSize: '14px',
            fontWeight: 400,
            marginTop: '10px',
            color: '#000',
          }}
        >
          {location?.state?.title}
        </div>
        <Button
          style={{
            width: '248px',
            height: '50px',
            borderRadius: '20px',
            backgroundColor: '#3076DD',
            color: '#FFF',
            marginTop: '40px',
            fontSize: 16,
          }}
          onClick={() => navigate('/boarding_management/add_a_model')}
        >
          <div>CREATE A NEW MODEL</div>
        </Button>
        <Button
          type={'link'}
          onClick={() => {
            navigate('/boarding_management', { state: { active_key: '1' } });
          }}
          style={{ color: '#E02C2C', marginTop: '10px' }}
        >
          <img
            src={'/icons/arrow_right.svg'}
            alt={'icon'}
            style={{ marginRight: '10px' }}
          />
          <span style={{ fontWeight: 500, fontSize: '14px', color: '#DD3030' }}>
            See all models
          </span>
        </Button>
      </div>
      <img
        src={'/assets/baloon.svg'}
        alt={'icon'}
        style={{
          pointerEvents: 'none',
          position: 'absolute',
          zIndex: '99',
          right: 0,
          bottom: 0,
        }}
      />
    </div>
  );
};

export default ChangeModelSucceed;
